module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('h2', {
    staticClass: "Verse-head",
    attrs: {
      "id": "_idParaDest-11"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor011"
    }
  }), _vm._v("Blind Interpreter")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Light-blinded")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("in my own blindness")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("I take the helm ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("of my unbridled")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("ship of fools.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Overladen")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("with information")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("erotic to the core")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("I crash the giant waves")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("of catastrophes")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("that surround us:")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("cities, water-starved ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("choked with every")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("driven thing, landscapes")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("frying in the sun –")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("I reach out, sightless,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("pleading for a future.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Like a slave-trader,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("lowest of the low,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("blinded now with insight")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("of a captain prophet,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("I turn my boat around")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("join those crying out for freedom:")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("all her simplicities")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-last"
  }, [_vm._v("and amazing grace")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-last"
  }, [_vm._v("in heartfelt prayer.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3706bb1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781398400801_EPUB-13.vue
// module id = 96
// module chunks = 0